export default __webpack_public_path__ + "static/media/LightBlue0006.5e968fa6.png";